import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useMemo } from 'react';
import initWebSocket from 'api/websocket';
import { getPaymentMethods } from '@redux/features/paymentMethodsSlice';
import { getLocations } from '@redux/features/locationsSlice';
import SessionStorageUtils from 'utils/SessionStorageUtils';
import { SessionStorageKeys } from 'constants/sessionStorageKeys';
import { routes } from 'constants/routes';
import { ProtectedLayout } from 'common/ProtectedLayout';
import { NotFound } from 'common/NotFound';
import { Sidebar } from 'common/Sidebar';
import { Notification } from 'components/Notification';
import { UserPage } from 'pages/Users/UserPage';
import { Choose } from 'pages/Locations/Choose';
import { Dashboard } from 'pages/Dashboard';
import { Auth } from 'pages/Auth';
import { Home } from 'pages/Home';
import styles from 'App.scss';

export default function App() {
  const { paymentMethods } = useSelector((state) => state.paymentMethods);
  const { locations } = useSelector((state) => state.locations);
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  const currentLocation = useMemo(() => SessionStorageUtils.getData(SessionStorageKeys.LOCATION), [pathname]);

  useEffect(() => {
    if (!locations.length) dispatch(getLocations());
  }, [dispatch, locations.length]);

  useEffect(() => {
    if (!paymentMethods.length) dispatch(getPaymentMethods());
  }, [dispatch, paymentMethods.length]);

  useEffect(() => {
    const cleanupWebSocket = initWebSocket(dispatch);
    return cleanupWebSocket;
  }, [dispatch]);

  return (
    <>
      <div className={styles.app}>
        <Sidebar />
        <div className={styles.pages}>
          <main className={styles.page} id='page'>
            <Routes>
              <Route path='/' element={<Home />} />
              <Route path='/auth' element={<Auth />} />

              <Route element={<ProtectedLayout />}>
                <Route path='/profile' element={<UserPage />} />
                <Route path='/locations/choose' element={<Choose />} />

                {locations.map(({ id, transliteration }) => (
                  <Route key={id} path={`/${transliteration}`} element={<Dashboard />} />
                ))}

                {currentLocation?.admin &&
                  routes.map(({ key, path, component: Component }) => (
                    <Route key={key} path={path} element={<Component />} />
                  ))}

                {currentLocation &&
                  routes.map(({ key, path, component: Component }) => (
                    <Route
                      key={`${currentLocation.transliteration}-${key}`}
                      path={`/:locationName${path}`}
                      element={<Component />}
                    />
                  ))}

                <Route path='*' element={<NotFound />} />
              </Route>

              <Route path='*' element={<Navigate to='/auth' replace />} />
            </Routes>
          </main>
        </div>
        <Notification />
      </div>

      <div className={styles.warning}>
        <span>😕</span>
        <p>Вибачте, цей пристрій замалий</p>
        <p className={styles.text}>Чутки кажуть, що з комп'ютера тут краще видно 🤔</p>
      </div>
    </>
  );
}
